import messages from "messages";
import styles from "./styles.module.css";

const IntervalConnector = () => (
  <div className={styles["interval-connector"]}>
    <span>{messages.to}</span>
  </div>
);

export default IntervalConnector;
